module.exports = __webpack_public_path__ + "img/power-switch.78fd44ac.png";